import {NgModule} from '@angular/core';
import {DottedLoaderDirective} from './dotted-loader.directive';

@NgModule({
    declarations: [DottedLoaderDirective],
    exports: [DottedLoaderDirective]
})
export class LoaderModule {
}